export function StatCard({ label, value, icon: Icon, color = "text-gray-900", isDark = false }) {
  return (
    <div className={`rounded-xl p-4 border ${isDark ? 'bg-[#12121a] border-white/10' : 'bg-white border-gray-200'}`} data-testid={`stat-${label.toLowerCase().replace(/\s+/g, '-')}`}>
      <div className="flex items-center gap-2 mb-2">
        <Icon size={18} className={isDark ? "text-gray-500" : "text-gray-400"} />
        <span className={`text-xs font-body ${isDark ? 'text-gray-500' : 'text-gray-400'}`}>{label}</span>
      </div>
      <p className={`text-2xl font-bold ${color}`}>{value}</p>
    </div>
  );
}
